import produce from 'immer';

export const Types = {
  GET_LISTA_ARQUIVOS_REQUEST: '@arquivoUpload/GET_LISTA_ARQUIVOS_REQUEST',
  GET_LISTA_ARQUIVOS_SUCCESS: '@arquivoUpload/GET_LISTA_ARQUIVOS_SUCCESS',
  GET_LISTA_ARQUIVOS_ERROR: '@arquivoUpload/GET_LISTA_ARQUIVOS_ERROR',
  GET_ARQUIVO_REQUEST: '@arquivoUpload/GET_ARQUIVO_REQUEST',
  GET_ARQUIVO_SUCCESS: '@arquivoUpload/GET_ARQUIVO_SUCCESS',
  GET_ARQUIVO_ERROR: '@arquivoUpload/GET_ARQUIVO_ERROR',
  GET_ATUALIZACAO_DE_RELATORIO_REQUEST:
    '@arquivoUpload/GET_ATUALIZACAO_DE_RELATORIO_REQUEST',
  GET_ATUALIZACAO_DE_RELATORIO_SUCCESS:
    '@arquivoUpload/GET_ATUALIZACAO_DE_RELATORIO_SUCCESS',
  GET_ATUALIZACAO_DE_RELATORIO_ERROR:
    '@arquivoUpload/GET_ATUALIZACAO_DE_RELATORIO_ERROR',
};

const INITIAL_STATE = {
  getListaArquivos: {
    loading: false,
    success: false,
    response: {
      dados: [],
      total: 0,
    },
    error: null,
  },
  getArquivo: {
    loading: false,
    success: false,
    response: [],
    error: null,
  },
};

export default function arquivoUpload(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_LISTA_ARQUIVOS_REQUEST: {
        draft.getListaArquivos.loading = true;
        break;
      }
      case Types.GET_LISTA_ARQUIVOS_SUCCESS: {
        draft.getListaArquivos.loading = false;
        draft.getListaArquivos.response = action.payload.response;
        draft.getListaArquivos.success = action.payload.success;
        draft.getListaArquivos.error = false;
        break;
      }
      case Types.GET_ATUALIZACAO_DE_RELATORIO_REQUEST: {
        draft.getListaArquivos.loading = false;
        break;
      }
      case Types.GET_ATUALIZACAO_DE_RELATORIO_SUCCESS: {
        draft.getListaArquivos.loading = false;
        const existingIndex = draft.getListaArquivos.response.dados.findIndex(
          (item) => item.taskId === action.payload.response.taskId
        );

        if (existingIndex !== -1) {
          // Se taskId existe, substituir os dados associados
          draft.getListaArquivos.response.dados[existingIndex] =
            action.payload.response;
        } else {
          return;
        }
        draft.getListaArquivos.success = action.payload.success;
        draft.getListaArquivos.error = false;
        break;
      }
      case Types.GET_LISTA_ARQUIVOS_ERROR: {
        draft.getListaArquivos.loading = false;
        draft.getListaArquivos.error = action.payload.error;
        draft.getListaArquivos.success = false;
        break;
      }
      case Types.GET_ARQUIVO_REQUEST: {
        draft.getArquivo.loading = true;
        break;
      }
      case Types.GET_ARQUIVO_SUCCESS: {
        draft.getArquivo.loading = false;
        draft.getArquivo.response = action.payload.response;
        draft.getArquivo.success = action.payload.success;
        draft.getArquivo.error = false;
        break;
      }
      case Types.GET_ARQUIVO_ERROR: {
        draft.getArquivo.loading = false;
        draft.getArquivo.error = action.payload.error;
        draft.getArquivo.success = false;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  getAtualizacaoDeRelatorioRequest: (taskId) => ({
    type: Types.GET_ATUALIZACAO_DE_RELATORIO_REQUEST,
    payload: { taskId },
  }),
  getAtualizacaoDeRelatorioSuccess: (response, success) => ({
    type: Types.GET_ATUALIZACAO_DE_RELATORIO_SUCCESS,
    payload: { response, success },
  }),
  getAtualizacaoDeRelatorioError: (error) => ({
    type: Types.GET_ATUALIZACAO_DE_RELATORIO_ERROR,
    payload: { error },
  }),
  getListaArquivosRequest: (
    codigoContratante,
    paginaInicial,
    quantidadeMaximaPorPagina
  ) => ({
    type: Types.GET_LISTA_ARQUIVOS_REQUEST,
    payload: { codigoContratante, paginaInicial, quantidadeMaximaPorPagina },
  }),
  getListaArquivosSuccess: (response, success) => ({
    type: Types.GET_LISTA_ARQUIVOS_SUCCESS,
    payload: { response, success },
  }),
  getListaArquivosError: (error) => ({
    type: Types.GET_LISTA_ARQUIVOS_ERROR,
    payload: { error },
  }),
  getArquivoRequest: (arquivoId) => ({
    type: Types.GET_ARQUIVO_REQUEST,
    payload: { arquivoId },
  }),
  getArquivoSuccess: (response, success) => ({
    type: Types.GET_ARQUIVO_SUCCESS,
    payload: { response, success },
  }),
  getArquivoError: (error) => ({
    type: Types.GET_ARQUIVO_ERROR,
    payload: { error },
  }),
};
